import { ServiceBusClient } from '@azure/service-bus';

const connectionString = process.env.CONNECTION_STRING;
const notificationTopic = process.env.TOPIC_NAME_NOTIFICATION;
const notificationSubscription = process.env.SUBSCRIPTION_NAME_WEB;

const sbClient = new ServiceBusClient(connectionString);

/**
 * Creates a receiver for receiving notifications from the Azure Service Bus.
 *
 * @returns {import('@azure/service-bus').ServiceBusReceiver} The Service Bus receiver instance.
 */
const createNotificationReceiver = async (sessionId: string) => {
  const receiver = await sbClient.acceptSession(
    notificationTopic,
    notificationSubscription,
    sessionId
  );

  return receiver;
};

export { createNotificationReceiver, sbClient };
